/**
 * Mismo patrón portal que panel-web: PageHeader inyecta su contenido
 * (title + subtitle + actions) en slots del AppShell vía createPortal.
 * Acá lo simplificamos: rendereamos inline (sin portal) porque el
 * AppShell del portal es más simple.
 */
import type { ReactNode } from "react";

export function PageHeader({
  title,
  subtitle,
  actions,
  eyebrow,
}: {
  title: string;
  subtitle?: string;
  actions?: ReactNode;
  eyebrow?: string;
}) {
  return (
    <div className="flex flex-col sm:flex-row sm:items-end sm:justify-between gap-3 sm:gap-4 mb-6 flex-wrap">
      <div className="space-y-1 min-w-0">
        {eyebrow && (
          <div className="text-xs font-semibold uppercase tracking-[0.18em] text-primary">
            {eyebrow}
          </div>
        )}
        <h1 className="text-2xl md:text-3xl font-display font-semibold text-base-content tracking-tight break-words">
          {title}
        </h1>
        {subtitle && (
          <p className="text-sm text-base-content/70 mt-2 max-w-2xl leading-relaxed">
            {subtitle}
          </p>
        )}
      </div>
      {actions && <div className="flex items-center gap-2 flex-wrap">{actions}</div>}
    </div>
  );
}
